import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=403d03cc&scoped=true&lang=pug&"
import script from "./Aside.vue?vue&type=script&lang=js&"
export * from "./Aside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403d03cc",
  null
  
)

export default component.exports